/**
 * Smooth section scroll without polluting the URL.
 * Handles #shopify-section-* anchors in hrefs like:
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'ageoneScrollToSection';
  const SECTION_HASH_RE = /#shopify-section-/;

  /** @param {string} href */
  function getSectionIdFromHref(href) {
    if (!href || !SECTION_HASH_RE.test(href)) return null;

    try {
      const url = new URL(href, window.location.href);
      if (!url.hash || !SECTION_HASH_RE.test(url.hash)) return null;
      return url.hash.slice(1);
    } catch {
      return null;
    }
  }

  function getScrollOffset() {
    const header = document.querySelector('#header-group, header, .header');
    return header ? header.offsetHeight : 0;
  }

  /** @param {string} sectionId @param {ScrollBehavior} behavior */
  function scrollToSection(sectionId, behavior = 'smooth') {
    const target = document.getElementById(sectionId);
    if (!target) return false;

    const top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();
    window.scrollTo({ top: Math.max(0, top), behavior });
    return true;
  }

  function stripHashFromUrl() {
    if (!window.location.hash) return;
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }

  /** @param {string} sectionId */
  function scrollWhenReady(sectionId) {
    let attempts = 25;

    const tryScroll = () => {
      if (scrollToSection(sectionId, attempts === 25 ? 'auto' : 'smooth')) return;
      if (attempts-- <= 0) return;
      setTimeout(tryScroll, 100);
    };

    tryScroll();
  }

  function handlePendingScroll() {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      sessionStorage.removeItem(STORAGE_KEY);
      scrollWhenReady(stored);
      return;
    }

    if (SECTION_HASH_RE.test(window.location.hash)) {
      const sectionId = window.location.hash.slice(1);
      stripHashFromUrl();
      scrollWhenReady(sectionId);
    }
  }

  document.addEventListener('click', function (event) {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    const sectionId = getSectionIdFromHref(href);
    if (!sectionId) return;

    let url;
    try {
      url = new URL(anchor.href, window.location.href);
    } catch {
      return;
    }

    const samePage =
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search;

    event.preventDefault();

    if (samePage) {
      scrollToSection(sectionId);
      stripHashFromUrl();
      return;
    }

    if (url.origin === window.location.origin) {
      sessionStorage.setItem(STORAGE_KEY, sectionId);
      window.location.assign(url.pathname + url.search);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handlePendingScroll);
  } else {
    handlePendingScroll();
  }
})();
